import { GridRenderCellParams } from '@mui/x-data-grid/models/params/gridCellParams'
import { GridColDef } from '@mui/x-data-grid-premium'
import { ReactNode } from 'react'
import { isDefined } from '@omnea-app/packages/universal/type-guards/isDefined'
import { BaseColumnConfig } from '../types'
import { baseColumnConfig } from './baseColumnConfig'
import type { GridValidRowModel } from '@mui/x-data-grid/models/gridRows'

export type CustomEditableColumnConfig<T extends GridValidRowModel> = BaseColumnConfig<T, 'custom-editable'> & {
  columnType: 'custom-editable'
  hideable?: boolean
  renderCell: (params: GridRenderCellParams) => ReactNode
  renderEditCell: GridColDef<T>['renderEditCell']
  minWidth?: number
  valueGetter?: GridColDef<T>['valueGetter']
  groupingValueGetter?: GridColDef<T>['groupingValueGetter']
  filterable?: boolean
}

export const getCustomEditableRenderColumn = <T extends GridValidRowModel>({
  style,
  ...config
}: CustomEditableColumnConfig<T>): GridColDef<T> => ({
  ...baseColumnConfig,
  ...style,
  ...config,
  groupingValueGetter: config.groupingValueGetter ?? config.valueGetter,
  renderCell: (params) => {
    if (!isDefined(params)) return null

    return config.renderCell(params)
  },
  editable: true,
})
